import React, { useCallback, useEffect, useState } from "react"
import { Dropdown } from "antd"
import dayjs from "dayjs"
import useMessage from "antd/es/message/useMessage"
import DateFilterStyle, { Filter, FilterText } from "./DateFilter.style"
import DateIcon from "components/Icons/DateIcon"
import RangePickerModal from "./DateRangePicker"
import { setInboxType, setSentType } from "redux/slice/commanSlice"
import { useAppDispatch } from "redux/hooks"

const DateFilter = ({ timeFormat, setSelectDate, dateFilter = "", faxActiveTab = "" ,className = ""}: any) => {
  const [isOpen, setIsOpen] = useState(false)
  const [message, contextMessage] = useMessage()
  const [selectedText, setSelectedText] = useState("")

  const dispatch = useAppDispatch();
  useEffect(() => {
    if (dateFilter !== "") {
      const action = labelToActionMap[dateFilter];
      if (action !== undefined) {
        handleOption(action);
      }
      setSelectedText(dateFilter)
    }
    else {
      pastDays(7)
      setSelectedText("Last 7 Days")
    }
  }, [faxActiveTab,dateFilter])

  const labelToActionMap: {
    [key: string]: string | undefined;
  } = {
    "All": "a",
    "Today": "t",
    "Yesterday": "y",
    "Last 7 Days": "",
    "Last 30 Days": "m",
    "Custom Range": undefined
  };

  const selectDate = useCallback(({ startDate, endDate, displayText = "" }: { startDate: string | undefined, endDate: string | undefined, displayText?: string }) => {
    if (dateFilter !== "" && faxActiveTab) {
      setSelectDate((prevState: { page?: string, per_page?: string, start_date?: string, end_date?: string, dateFilterIn?: string, dateFilterOut?: string }) => {
        const newState = {
          ...prevState,
          page: "1",
          per_page: "10",
          start_date: startDate,
          end_date: endDate,
        };
        if (faxActiveTab === "inbox") {
          dispatch(setInboxType(displayText));
          
        } else if (faxActiveTab === "fax") {
         dispatch(setSentType(displayText));

        }
        return newState
      });
    } else {
      setSelectDate({
        startDate,
        endDate
      })
    }
  }, [selectedText, dateFilter, faxActiveTab, setSelectDate])

  const pastDays = (days: number) => {
    const currentDate = dayjs() // Get the current date
    const pastWeekDate = currentDate.subtract(days, "day") // Subtract 6 days from the current date
    let displayText = "";

    if (days === 30) {
      displayText = "Last 30 Days";
    } else if (days === 7) {
      displayText = "Last 7 Days";
    }

    const endDate = currentDate.endOf("day").format("YYYY-MM-DD HH:mm") // Format the start date
    const startDate = pastWeekDate.startOf("day").format("YYYY-MM-DD HH:mm") // Format the end date
    selectDate({
      startDate,
      endDate,
      displayText
    })
  }

  const getToday = () => {
    const now = dayjs();
    const startDate = now.startOf("day").format("YYYY-MM-DD HH:mm");
    const endDate = now.endOf("day").format("YYYY-MM-DD HH:mm");

    selectDate({
      startDate,
      endDate,
      displayText: "Today"
    });
  };

  const getYesterday = () => {
    // Get current date and time
    const now = dayjs()

    // Subtract 1 day to get yesterday's date and time
    const yesterday = now.subtract(1, "day")

    // Format the date and time range
    const startDate = yesterday.startOf("day").format("YYYY-MM-DD HH:mm")
    const endDate = yesterday.endOf("day").format("YYYY-MM-DD HH:mm")
    selectDate({
      startDate,
      endDate,
      displayText: "Yesterday"
    })
  }

  const handlecustomeDate = (dates: [string, string]) => {
    const startDate = dayjs(dates[0]).format("YYYY-MM-DD HH:mm")
    const endDate = dayjs(dates[1]).format("YYYY-MM-DD HH:mm")
    let displayText
    const daysDifference = dayjs(endDate).diff(startDate, "days")

    if (daysDifference > 31) {
      message.error("The date range must not have exceed more than 31 days.")
      return
    }

    if (timeFormat === "12") {
      const displayStartDate = dayjs(dates[0])
        .locale("en")
        .format("DD MMM YYYY, h:mm a")

      const displayEndDate = dayjs(dates[1])
        .locale("en")
        .format("DD MMM YYYY, h:mm a")

      setSelectedText(`${displayStartDate} - ${displayEndDate}`)
      displayText = `${displayStartDate} - ${displayEndDate}`
    } else {
      const displayStartDate = dayjs(dates[0])
        .locale("en")
        .format("DD MMM YYYY, HH:mm")

      const displayEndDate = dayjs(dates[1])
        .locale("en")
        .format("DD MMM YYYY, HH:mm")

      setSelectedText(`${displayStartDate} - ${displayEndDate}`)
      displayText = `${displayStartDate} - ${displayEndDate}`
    }

    setIsOpen(false)
    selectDate({
      startDate,
      endDate,
      displayText
    })
  }

  const handleOption = (opt: any) => {
    switch (opt) {
      case "a": {
        setSelectedText("All")
        selectDate({ startDate: undefined, endDate: undefined, displayText: 'All' })
        break;
      }

      case "y": {
        setSelectedText("Yesterday")
        getYesterday()
        break
      }

      case "t": {
        setSelectedText("Today")
        if (dateFilter !== "" && faxActiveTab) {
          getToday()
          return
        }
        selectDate({
          startDate: "",
          endDate: ""
        })
        break
      }

      case "m": {
        setSelectedText("Last 30 Days")
        pastDays(30)
        break
      }

      default: {
        pastDays(7)
        setSelectedText("Last 7 Days")
        break
      }
    }
  }

  const isSelectedItem = () => {
    if (
      selectedText === "All" ||
      selectedText === "Today" ||
      selectedText === "Yesterday" ||
      selectedText === "Last 7 Days" ||
      selectedText === "Last 30 Days"
    ) {
      return ""
    }
    return "dropdown-item-custom-range"
  }

  return (
    <DateFilterStyle className={className}>
      {contextMessage}
      <Dropdown
        trigger={["click"]}
        menu={{
          items: [
            {
              key: "0",
              label: <div>All</div>,
              onClick: () => handleOption("a")
            },
            {
              key: "1",
              label: <div>Today</div>,
              onClick: () => handleOption("t")
            },
            {
              key: "2",
              label: <div>Yesterday</div>,
              onClick: () => handleOption("y")
            },
            {
              key: "3",
              label: <div>Last 7 Days</div>,
              onClick: () => handleOption("")
            },
            {
              key: "4",
              label: <div>Last 30 Days</div>,
              onClick: () => handleOption("m")
            },
            {
              key: "5",
              className: isSelectedItem(),
              label: <div>Custom Range</div>,
              onClick: () => setIsOpen(true)
            }
          ]
        }}
        overlayClassName="ant-dropdown-bordered"
      >
        <a href="/" onClick={(e) => e.preventDefault()}>
          <Filter>
            <DateIcon />
            <FilterText>{selectedText}</FilterText>
          </Filter>
        </a>
      </Dropdown>
      <RangePickerModal
        isOpen={isOpen}
        timeFormat={timeFormat}
        onCancel={() => setIsOpen(false)}
        onChange={(dates: any) => handlecustomeDate(dates)}
      />
    </DateFilterStyle>
  )
}

export default DateFilter
